import { FiChevronDown } from 'react-icons/fi'

import { useMapContext } from '../MapContext'

interface GroupFilterProps {
  onSelect: () => void
}

export const GroupFilter = ({ onSelect }: GroupFilterProps) => {
  const { filters, setFilters, assetGroups } = useMapContext()

  const options: { value: number | undefined; label: string }[] = [
    { value: undefined, label: 'All' },
    ...assetGroups.map((g) => ({ value: g.id, label: g.name })),
  ]

  const handleChange = (value: number | undefined) => {
    setFilters({ ...filters, groupId: value })
    onSelect()
  }

  const currentLabel = options.find((o) => o.value === filters.groupId)?.label ?? 'All'

  const DesktopContent = () => (
    <div className="dropdown hidden md:block" data-filter-dropdown>
      <div
        tabIndex={0}
        role="button"
        className="btn btn-sm btn-outline min-w-[135px] flex items-center justify-between font-normal"
      >
        <span>Group: {currentLabel}</span>
        <FiChevronDown className="w-4 h-4 text-base-content/60" />
      </div>
      <ul
        tabIndex={0}
        className="dropdown-content menu bg-base-100 rounded-lg shadow-lg border border-base-300 z-20 w-full p-1 mt-1 max-h-72 overflow-y-auto flex-nowrap"
      >
        {options.map((opt) => (
          <li key={opt.value ?? 'all'}>
            <button
              onClick={() => handleChange(opt.value)}
              className={`text-xs ${filters.groupId === opt.value ? 'active' : ''}`}
            >
              {opt.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )

  const MobileContent = () => (
    <div className=" md:hidden flex flex-col gap-2">
      <label className="text-base"> Group </label>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <button
            key={opt.value ?? 'all'}
            onClick={() => handleChange(opt.value)}
            className={`btn btn-sm rounded-full px-6 ${filters.groupId === opt.value ? 'btn-primary' : 'btn-outline'}`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  )

  return (
    <>
      <DesktopContent />
      <MobileContent />
    </>
  )
}
